import { inject, Injectable, signal } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { FieldTree } from '@angular/forms/signals';
import { TranslateService } from '@ngx-translate/core';

export interface Message {
    severity: 'success' | 'info' | 'warn' | 'error';
    text: string;
}

@Injectable({ providedIn: 'root' })
export class SignalFormValidationService {
    translateService = inject(TranslateService);
    _showMessage = signal(false);
    _messages = signal<Message[]>([]);
    public readonly showMessage = this._showMessage.asReadonly();
    public readonly messages = this._messages.asReadonly();

    private focusInvalidControl(): void {
        setTimeout(() => {
            // For signal forms, look for invalid inputs
            const firstInvalid: HTMLElement | null = document.querySelector('input.ng-invalid, select.ng-invalid, textarea.ng-invalid');
            if (firstInvalid) {
                firstInvalid.focus();
                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    }

    /**
     * Load validation messages from signal-based form
     */
    loadMessageError<T>(errors: ValidationErrors[]): void {
        // console.log(field.errors, 'field');
        this.focusInvalidControl();
        const messages: Message[] = [];
        errors.forEach((error: any) => {
            const message = this.translateService.instant(error.message);
            messages.push({ severity: 'error', text: message });
        });
        this._messages.set(messages);
        setTimeout(() => {
            this._showMessage.set(true);


        },80)
    }

    clearMessages(): void {
        this._showMessage.set(false);
        this._messages.set([]);
    }

    markAllAsTouched(field: FieldTree<any>): void {
        Object.values(field).forEach((fieldSignal: any) => {
            try {
                const field = typeof fieldSignal === 'function'
                    ? fieldSignal()
                    : fieldSignal;

                const adapter = field?.fieldAdapter;
                const proxy = field?.fieldProxy;
                const nodeState = field?.nodeState;

                if (typeof adapter?.markAsTouched === 'function') {
                    adapter.markAsTouched();
                } else if (typeof proxy?.markAsTouched === 'function') {
                    proxy.markAsTouched();
                } else if (typeof nodeState?.selfTouched?.set === 'function') {
                    nodeState.selfTouched.set(true); // 👈 directly set the signal
                }
            } catch (e) {
                // skip non-field values
            }
        });
    }
}
